exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Vacancies-module__wrapper___36ap9{padding:64px 0;display:grid;gap:48px}@media screen and (min-width:768px){.Vacancies-module__wrapper___36ap9{grid-template-columns:288px 1fr}}.Vacancies-module__wrapper___36ap9 .Vacancies-module__cards___Ngjel{display:grid;gap:24px;align-content:start}", ""]);

// exports
exports.locals = {
	"wrapper": "Vacancies-module__wrapper___36ap9",
	"cards": "Vacancies-module__cards___Ngjel"
};